import wx from 'weixin-js-sdk'
import { GetWxParams } from '../service/api'

const wxshare = function (option) {
  // option是分享的配置内容
  const url = window.location.href.split('#')[0]
  window.console.log(url, JSON.stringify(option))
  GetWxParams({ url }).then((response) => {
    console.log('success')
    wx.config({
      debug: false,
      appId: response.appId,
      timestamp: response.timestamp,
      nonceStr: response.nonceStr,
      signature: response.signature,
      jsApiList: [
        'updateAppMessageShareData',
        'updateTimelineShareData',
        'chooseImage',
        'previewImage'
      ],
      openTagList: ['wx-open-launch-weapp']
    })
  }).catch(error => {
    console.log('err')
    window.console.log(error)
  })
  wx.ready(function () {
    wx.updateAppMessageShareData({
      title: option.shareTitle,
      desc: option.shareDesc,
      link: option.shareUrl,
      imgUrl: option.shareImg,
      success:function () {
        this.$toast('分享成功')
      }
    })
    wx.updateTimelineShareData({
      title: option.shareTitle,
      desc: option.shareDesc,
      link: option.shareUrl,
      imgUrl: option.shareImg,
      success:function () {
        this.$toast('分享成功')
      }
    })
  })
}

export { wxshare }